export default "__VITE_ASSET__DeOApmm5__"